import { render, staticRenderFns } from "./VacancyStatsMulti.vue?vue&type=template&id=4af6a117&"
import script from "./VacancyStatsMulti.vue?vue&type=script&lang=js&"
export * from "./VacancyStatsMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports